<template>
  <a :rel="opensInNewWindow ? 'noopener' : null" @click="processLink" v-html="title" />
</template>

<script>
import axios from 'axios';

export default {
  name: 'RefLink',
  props: {
    title: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    assetType: {
      type: String,
      default: undefined,
    },
    assetLocation: {
      type: String,
      default: undefined,
    },
    target: {
      type: String,
      default: undefined,
    },
    reportName: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    isAzureLink() {
      return this.assetLocation === 'Azure';
    },
    isScene7Link() {
      return this.assetLocation === 'Scene7';
    },
    isPlainLink() {
      return !this.isAzureLink && !this.isScene7Link;
    },
    isContent() {
      return this.assetType === 'content';
    },
    linkTarget() {
      return this.opensInNewWindow ? '_blank' : '_self';
    },
    opensInNewWindow() {
      return this.target?.toUpperCase() === 'NEWWINDOW';
    },
  },
  methods: {
    processLink() {
      if (this.isAzureLink) {
        if (this.reportName) {
          this.openGptwReportLink();
        } else {
          this.openAzureLink();
        }
      }

      if (this.isScene7Link) {
        this.openScene7Link();
      }
      if (this.isPlainLink) {
        window.open(this.link, this.linkTarget);
      }
    },

    openAzureLink() {
      axios
        .get(`/product/spec/processLink?assetLocation=${this.assetLocation}&linkUrl=${escape(this.link)}`)
        .then(({data}) => {
          if (data && data.data) {
            window.open(data.data, this.linkTarget);
          } else {
            console.log('Bad document link returned: ' + data.data);
          }
        })
        .catch((error) => {
          alert('Document link generation error: ' + error);
          console.log(error);
        });
    },

    openGptwReportLink() {
      axios
        .get(`/scorecard/processGptwLink?assetLocation=${this.assetLocation}&linkUrl=${escape(this.link)}`)
        .then(({data}) => {
          if (data && data.data) {
            window.open(data.data, this.linkTarget);
          }
        })
        .catch((error) => {
          console.error('Document link generation error: ' + error);
        });
    },

    openScene7Link() {
      const prefix = `//trek.scene7.com/is/${this.isContent ? 'content' : 'image'}/TrekBicycleProducts/`;
      const suffix = this.isContent
        ? ''
        : '?wid=160&amp;amp;hei=120&amp;amp;fmt=png8-alpha&amp;amp;qlt=80,1&amp;amp;op_usm=0,0,0,0&amp;amp;iccEmbed=0&amp;amp;cache=on,on';
      window.open(prefix + this.link + suffix, this.linkTarget);
    },
  },
};
</script>
